module.exports = __webpack_public_path__ + "static/media/aboutUAICLeft.aa78c24d.svg";